import React from "react";
import {
  Autocomplete,
  TextField,
  CircularProgress,
  Stack,
  Box,
  Chip,
  Typography,
} from "@mui/material";

const FlavorIngredientsSection = ({
  ingredientsOptions,
  loadingIngredients,
  formData,
  setFormData,
}) => {
  return (
    <>
      <Autocomplete
        multiple
        disableCloseOnSelect
        options={ingredientsOptions}
        loading={loadingIngredients}
        getOptionLabel={(option) => option.name}
        isOptionEqualToValue={(option, value) => option._id === value._id}
        value={formData.ingredients}
        onChange={(e, newValue) =>
          setFormData({ ...formData, ingredients: newValue })
        }
        renderInput={(params) => (
          <TextField
            {...params}
            label="Ingredients"
            placeholder="Search ingredients"
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {loadingIngredients ? <CircularProgress size={20} /> : null}
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
            sx={{ my: 1 }}
          />
        )}
      />

      {formData.ingredients.length > 0 && (
        <Box
          sx={{
            mt: 1,
            maxHeight: 180,
            overflowY: "auto",
            border: "1px solid #eee",
            borderRadius: 2,
            p: 1,
          }}>
          <Typography variant="subtitle2" sx={{ mb: 1 }}>
            Selected Ingredients:
          </Typography>
          <Stack direction="row" spacing={1} flexWrap="wrap">
            {formData.ingredients.map((ing) => (
              <Chip
                key={ing._id}
                label={ing.name}
                onDelete={() =>
                  setFormData({
                    ...formData,
                    ingredients: formData.ingredients.filter(
                      (i) => i._id !== ing._id
                    ),
                  })
                }
              />
            ))}
          </Stack>
        </Box>
      )}
    </>
  );
};

export default FlavorIngredientsSection;
